import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

import type { GridState } from './ltl.grid.reducer';

export const selectCurrentPageShipmentIds = (state: GridState) => state.currentPageShipmentIds ?? emptyArray;
export const selectPage = (state: GridState) => state.page ?? 1;
export const selectPageSize = (state: GridState) => state.pageSize ?? 50;
export const selectTotalRecords = (state: GridState) => state.totalRecords ?? 0;
export const selectTotalPages = (state: GridState) => state.totalPages ?? 0;
export const selectIsLoading = (state: GridState) => state.isLoading ?? false;
export const selectSelectedShipmentIds = (state: GridState) => state.selectedShipmentIds ?? emptyArray;
export const selectActiveFilters = (state: GridState) => state.activeFilters ?? emptyObject;
export const selectStatusFilter = (state: GridState) => state.statusFilter ?? null;
